"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetSelectedMethod;

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

function useGetSelectedMethod(methods) {
  var formData = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('payout-create'));

  if (formData && 'method' in formData && formData['method']) {
    return formData['method'];
  }

  return methods.length ? methods[0] : null;
}